module.exports = __webpack_public_path__ + "img/fotCode.e8f6408f.png";